{
  "schema_version": 1,
  "task_id": "L5-USER-DECISION-ACTIVATION-PACK-001",
  "status": "activation-pack-ready",
  "generated_at": "2026-07-31T06:35:00+08:00",
  "source_decision_center": "config/l5-user-decision-center.json",
  "document": "docs/handoff/AIOS_L5_User_Decision_Activation_Pack_用户决策激活包_v1.0.md",
  "authority_boundary": {
    "observational_only": true,
    "formal_gate_replacement": false,
    "mutation_authority": false,
    "approval_authority": false,
    "stores_user_decisions": false,
    "collects_secrets": false,
    "embeds_secret_values": false,
    "cloud_sync": false,
    "ecosystem_publish": false,
    "external_distribution": false,
    "external_write": false,
    "paid_action": false,
    "secret_storage": false,
    "deployment": false,
    "runtime_activation": false,
    "model_call": false,
    "task_completion_authority": false
  },
  "summary": {
    "activation_pack_count": 3,
    "source_decision_count": 3,
    "can_start_now_count": 0,
    "external_effect_count": 0,
    "secret_values_embedded_count": 0,
    "copy_prompts_count": 3,
    "default_safe_next_action": "continue-local-product-polish"
  },
  "packs": [
    {
      "id": "ACTIVATE-REAL-CLOUD-SYNC",
      "source_decision_id": "L5-REAL-CLOUD-SYNC-USER-DECISION-001",
      "category": "cloud-sync",
      "title_zh": "真实云同步激活包",
      "title_en": "Real cloud-sync activation pack",
      "user_decision_required": true,
      "can_start_now": false,
      "current_allowed_effect": "prepare_activation_task_spec_only",
      "copy_prompt_zh": "我批准进入真实云同步激活 Task Spec 准备；暂不粘贴任何密钥。我的选择是：云服务商=<填写>，账号/责任人=<填写>，Secret 注入路径=<填写方式不含密钥值>，费用停止线=<填写>，同步数据范围=<填写>，冲突策略=<填写>，回滚验收=<填写>。",
      "copy_prompt_en": "I approve preparing the real cloud-sync activation Task Spec; I will not paste any secret values. My choices are: provider=<fill>, account/owner=<fill>, Secret injection path=<method only, no secret value>, cost stop line=<fill>, data scope=<fill>, conflict policy=<fill>, rollback acceptance=<fill>.",
      "required_user_inputs": [
        "provider",
        "account_owner",
        "oauth_secret_path",
        "cost_budget",
        "data_scope",
        "conflict_policy",
        "rollback_owner"
      ],
      "activation_sequence": [
        "user_choice",
        "activation_task_spec",
        "secret_path_confirmation",
        "read_only_preflight",
        "small_scope_canary",
        "rollback_drill",
        "independent_reviewer",
        "explicit_user_go"
      ],
      "local_preparation_outputs": [
        "docs/specs/L5-REAL-CLOUD-SYNC-ACTIVATION-TASK-SPEC.md",
        "artifacts/evidence/L5-REAL-CLOUD-SYNC-ACTIVATION-001",
        "rollback-plan",
        "reviewer-request"
      ],
      "forbidden_actions_until_user_go": [
        "connect_account",
        "start_oauth",
        "store_secret",
        "cloud_read",
        "cloud_write",
        "runtime_activation",
        "external_write",
        "paid_action"
      ],
      "stop_conditions": [
        "missing_secret_path",
        "unknown_cost_boundary",
        "no_rollback_owner",
        "failed_read_only_preflight",
        "reviewer_fail"
      ]
    },
    {
      "id": "ACTIVATE-ECOSYSTEM-PUBLISHING",
      "source_decision_id": "L5-ECOSYSTEM-PUBLISHING-ACTIVATION-USER-DECISION-001",
      "category": "ecosystem-publishing",
      "title_zh": "生态发布激活包",
      "title_en": "Ecosystem publishing activation pack",
      "user_decision_required": true,
      "can_start_now": false,
      "current_allowed_effect": "prepare_activation_task_spec_only",
      "copy_prompt_zh": "我批准进入生态发布激活 Task Spec 准备；暂不发布、不安装、不提交市场、不粘贴密钥。我的选择是：发布目标=<填写>，许可/署名=<填写>，发布账号=<填写>，费用/配额=<填写>，撤回路径=<填写>，对外支持边界=<填写>。",
      "copy_prompt_en": "I approve preparing the ecosystem publishing activation Task Spec; do not publish, install, submit marketplaces, and do not paste secrets yet. My choices are: target=<fill>, license/attribution=<fill>, publishing account=<fill>, cost/quota=<fill>, unpublish path=<fill>, support boundary=<fill>.",
      "required_user_inputs": [
        "publication_target",
        "license_attribution",
        "publishing_account",
        "cost_policy",
        "unpublish_path",
        "support_boundary"
      ],
      "activation_sequence": [
        "user_choice",
        "publishing_task_spec",
        "license_review",
        "security_review",
        "distribution_dry_run",
        "rollback_plan",
        "independent_reviewer",
        "explicit_user_go"
      ],
      "local_preparation_outputs": [
        "docs/specs/L5-ECOSYSTEM-PUBLISHING-ACTIVATION-TASK-SPEC.md",
        "artifacts/evidence/L5-ECOSYSTEM-PUBLISHING-ACTIVATION-001",
        "license-and-attribution-review",
        "reviewer-request"
      ],
      "forbidden_actions_until_user_go": [
        "cloud_write",
        "publish_plugin",
        "publish_skill",
        "submit_marketplace",
        "external_distribution",
        "external_write",
        "external_message",
        "runtime_activation",
        "store_secret",
        "paid_action"
      ],
      "stop_conditions": [
        "missing_license_choice",
        "unknown_publishing_account",
        "unknown_cost_boundary",
        "missing_unpublish_path",
        "reviewer_fail"
      ]
    },
    {
      "id": "ACTIVATE-PRODUCTION-EXTERNAL-DISTRIBUTION",
      "source_decision_id": "L5-EXTERNAL-DISTRIBUTION-USER-DECISION-001",
      "category": "external-distribution",
      "title_zh": "生产级外部分发激活包",
      "title_en": "Production external-distribution activation pack",
      "user_decision_required": true,
      "can_start_now": false,
      "current_allowed_effect": "prepare_activation_task_spec_only",
      "copy_prompt_zh": "我批准进入生产级外部分发激活 Task Spec 准备；暂不部署、不分发、不对外发送消息、不粘贴密钥。我的选择是：法律主体/账号=<填写>，分发策略=<填写>，费用与支持责任=<填写>，回滚与事故预案=<填写>，对外沟通边界=<填写>。",
      "copy_prompt_en": "I approve preparing the production external-distribution activation Task Spec; do not deploy, distribute, send external messages, and do not paste secrets yet. My choices are: legal entity/account=<fill>, distribution policy=<fill>, cost/support responsibility=<fill>, rollback/incident plan=<fill>, external communication boundary=<fill>.",
      "required_user_inputs": [
        "legal_account",
        "distribution_policy",
        "cost_support",
        "rollback_incident_plan",
        "external_communication"
      ],
      "activation_sequence": [
        "user_choice",
        "distribution_task_spec",
        "legal_and_license_review",
        "cost_review",
        "support_and_incident_review",
        "rollback_drill",
        "independent_reviewer",
        "explicit_user_go"
      ],
      "local_preparation_outputs": [
        "docs/specs/L5-PRODUCTION-EXTERNAL-DISTRIBUTION-TASK-SPEC.md",
        "artifacts/evidence/L5-PRODUCTION-EXTERNAL-DISTRIBUTION-001",
        "support-and-incident-plan",
        "reviewer-request"
      ],
      "forbidden_actions_until_user_go": [
        "cloud_write",
        "production_distribution",
        "external_write",
        "external_message",
        "deployment",
        "store_secret",
        "paid_action",
        "runtime_activation"
      ],
      "stop_conditions": [
        "missing_legal_account_choice",
        "unknown_cost_boundary",
        "missing_support_owner",
        "missing_rollback_incident_plan",
        "reviewer_fail"
      ]
    }
  ],
  "handoff_integration": {
    "project_status": "config/aios-project-status.json",
    "final_handoff_pack": "config/l5-final-handoff-pack.json",
    "decision_center": "config/l5-user-decision-center.json",
    "must_remain_readonly": true,
    "must_not_store_user_choices": true,
    "must_not_collect_secrets": true
  }
}
